//全局配置参数
import axios from 'axios';
import Vue from 'vue';
import ele from 'element-ui';
import _ from 'lodash';
export default {
  name: 'golbal',
  namespaced: true,
  state: {
    SignData: null,
    //系统上线年份，财务报表所需
    SystemLaunchYear: 2022,
    //小数位数
    DecimalScale: {
      //数量 2位
      Quantity: 2,
      //单价 8位
      Price: 8,
      //金额 2位
      Amount: 2,
      //汇率折算：2位
      Rate: 2
    },
    DefaultPartnerType: {
      // 菜籽供应商默认性质
      Rapeseed: { Id: '226', Descr: '供应商' }
    },
    DefaultPartnerClass: {
      // 菜籽供应商默认分类
      Rapeseed: { Id: '3', Descr: '供应商' }
    },
    //默认币种
    DefaultCurrency: {
      Id: '58dabdb1-73a3-4803-8821-771ee0c56503',
      Code: 'RMB',
      Descr: '人民币',
      Rate: 1.0
    },
    //存货分类
    InventoryClass: {
      //ProduceMaterial: { Id: '1', Descr: '原材料' },
      //Rapeseed: { Id: '22', Descr: '油菜籽' },
      //Product: { Id: '4', Descr: '产成品' },
      //MiddleProduct: { Id: '3', Descr: '半成品' },
      //MiddleProduct_Oil: { Id: '21', Descr: '半成品-毛油' },
      //Additive: { Id: '42', Descr: '添加剂' },
      //PackageOil: { Id: '15', Descr: '小包装' },
      //PackagingMaterial: { Id: '2', Descr: '包装物' },
      //SpareParts: { Id: '5', Descr: '备品备件' },
      //LowValueConsumables: { Id: '6', Descr: '低值易耗品' },
      //ChemicalSupplies: { Id: '27', Descr: '化学用品' },
      // MiddleProduct_Meal: { Id: '44', Descr: '半成品-粕' },  //  测试版
      //MiddleProduct_Meal: { Id: '42', Descr: '半成品-粕' } //  正式版
    },
    //质检模板
    QTTemplate: {
      //成品油脂检验报告
      PackageOil_GYS: { Id: 'afd91060-1f2d-43f0-93f8-df1dfc7e6c42' }
    },
    Department: {
      QT: { Id: '10', Code: '010', Descr: '质检部' }
    },
    Executor: {
      id: null,
      user_name: null,
      full_name: null,
      validate_status: null,
      role_id: null
    },
    Options: {
      DblClickOpenAction: 'edit', //双击打开模式：view=浏览，不允许修改，edit=修改
      BaseDataCanAdd: false, //  基础数据是否可新增（基础数据指需从拥有同步的数据）
      BaseDataCanEdit: false, //  基础数据是否可修改（基础数据指需从拥有同步的数据）
      BaseDataCanDelete: false //  基础数据是否可删除（基础数据指需从拥有同步的数据）
    },
    PageSize: {
      Normal: 20, //默认每页数据量
      Max: 999, //默认每页数据量
      Min: 10 //默认每页数据量
    },
    Format: {
      ShortDate: 'yy-MM-DD',
      Date: 'yyyy-MM-DD',
      DateTime: 'yyyy-MM-DD HH:mm:ss',
      ShortDateTime: 'yyyy-MM-DD HH:mm',
      ShortTime: 'HH:mm',
      Time: 'HH:mm:ss'
    },
    //枚举类型类名
    EnumNames: {
      Storage_PalletInfo_State: 'Storage_PalletInfo_State',
      Storage_PalletInfo_Usage: 'Storage_PalletInfo_Usage',
      Storage_PalletInfo_RFFlag: 'Storage_PalletInfo_RFFlag',

      SYS_RestoreRule_State: 'SYS_RestoreRule_State',
      SYS_RestoreRule_RestoreMode: 'SYS_RestoreRule_RestoreMode',

      Storage_StorageSort_State: 'Storage_StorageSort_State',

      Storage_WarehouseInfo_State: 'Storage_WarehouseInfo_State',

      BaseData_RDStyle_Flag: 'BaseData_RDStyle_Flag',
      BaseData_Currency_CalcSort: 'BaseData_Currency_CalcSort',

      BaseDataStateEnum: 'BaseDataStateEnum',
      BaseDataSexEnum: 'BaseDataSexEnum',
      RapeseedBuyTempEnum: 'RapeseedBuyTempEnum',
      QTTypeEnum: 'QTTypeEnum',
      QTDetailValueTypeEnum: 'QTDetailValueTypeEnum',
      PrevRDFactoryStateEnum: 'PrevRDFactoryStateEnum',

      PreInStoreBillState: 'PreInStoreBillState', //  出入厂单 - 单据状态
      PreInStore_PreQTState: 'PreInStore_PreQTState', //  出入厂单 - 初检状态
      PreInStore_QTState: 'PreInStore_QTState', //  出入厂单 - 复检状态
      PreInStore_GrossState: 'PreInStore_GrossState', //  出入厂单 - 过皮重状态
      PreInStore_UnladenState: 'PreInStore_UnladenState', //  出入厂单 - 过毛重状态
      PreInStore_LoadState: 'PreInStore_LoadState', //  出入厂单 - 装卸状态
      PreInStore_BillDirection: 'PreInStore_BillDirection', //  出入厂单 - 入厂分类
      PreInStore_ScaleSort: 'PreInStore_ScaleSort', //  出入厂单 - 过磅分类
      PreInStore_PreQTPass: 'PreInStore_PreQTPass', //  出入厂单 - 质检结果
      PreInStore_QTPass: 'PreInStore_QTPass', //  出入厂单 - 质检结果
      PreInStore_BillType: 'PreInStore_BillType', //  出入厂单 - 单据分类

      Energy_Report_StateEnum: 'Energy_Report_StateEnum', //能源报表状态
      Energy_Report_RecordModeEnum: 'Energy_Report_RecordModeEnum', //能源报表采集模式

      Pallet_PalletRegister_State: 'Pallet_PalletRegister_State',
      Pallet_PalletLend_State: 'Pallet_PalletLend_State',
      Pallet_PalletReturn_State: 'Pallet_PalletReturn_State',
      Pallet_PalletScrap_State: 'Pallet_PalletScrap_State',
      Pallet_PalletRDBill_State: 'Pallet_PalletRDBill_State',
      Pallet_PalletRDBill_RDFlag: 'Pallet_PalletRDBill_RDFlag',
      Pallet_PalletInfo_State: 'Pallet_PalletInfo_State',
      Pallet_PalletInfo_Usage: 'Pallet_PalletInfo_Usage',
      Pallet_PalletInfo_RFFlag: 'Pallet_PalletInfo_RFFlag',
      PurchaseRequisitionState: 'PurchaseRequisitionState', //请购单状态
      EnergyReportTypeEnum: 'EnergyReportTypeEnum', //能源报表类型

      EquipmentLocationShift_StateEnum: 'EquipmentLocationShift_StateEnum', //排班表状态

      QT_InventoryLevel: 'QT_InventoryLevel', //过程质检：油品等级
      QT_InventoryPT: 'QT_InventoryPT' //  过程质检：油品工艺
    },
    //枚举类型缓存
    EnumCache: {},
    //  输入控件结果缓存，全部数据第一页
    InputboxCache: {},
    //  用于从子页打开新的标签页
    OpenComponentOnTab: {
      //  组件名
      menu_component: null,
      //  目录名
      menu_name: null,
      //参数
      params: {}
    },
    // 刷新方法
    RefreshMethod: {
      method_name: null
    }
  },
  actions: {
    queryableInventoryClass(context) {
      const inventoryClass = context.state.InventoryClass;
      if (Object.keys(inventoryClass).length == 0) {
        axios
          .get("InventoryClass/GetInventoryClassOptions")
          .then(response => {
            const obj = response.data;
            if (obj && Object.keys(obj).length > 0)
              context.commit('SETINVENTORYCLASS', obj);
          })
          .catch(error => {
            if (error.response) {
              ele.Message.error(error.response.data.Message);
            } else {
              ele.Message.error(error);
            }
          });
      }
    },
    //  向后台请求枚举类型值
    //  入参：{name：枚举类型名}
    queryableEnums(context, value) {
      axios
        .post(`Enum/ValuesObject?enumType=${value.name}`)
        .then(response => {
          if (response.data.Result == false) {
            ele.Message.error(response.data.Message);
          } else {
            context.commit('SETENUMCACHE', { name: value.name, enums: response.data });
          }
        })
        .catch(error => {
          if (error.response) {
            ele.Message.error(error.response.data.Message);
          } else {
            ele.Message.error(error);
          }
        });
    },
    //  加载枚举类型值
    //  入参：{name：枚举类型名}
    loadEnums(context, value) {
      var enums = context.state.EnumCache[value.name];
      if (!enums || enums.length == 0) {
        context.dispatch('queryableEnums', value);
      }
    },
    //  写入debug
    WriteDebug(context, value) {
      axios
        .get(`Logger/Debug?msg=${value}`)
        .then()
        .catch();
    }
  },
  mutations: {
    SETINVENTORYCLASS(state, value) {
      if (value) state.InventoryClass = value;
    },
    // 将用户签名写入Vuex
    SETSIGNDATA(state, value) {
      if (value) state.SignData = value;
    },
    //  将操作员信息存入Vuex
    SETEXECUTOR(state, value) {
      if (value) {
        for (const key in state.Executor) {
          state.Executor[key] = value[key];
        }
      } else {
        for (const key in state.Executor) {
          state.Executor[key] = null;
        }
      }
    },
    //  将枚举类型值存入state.EnumCache
    //  入参：{name：枚举类型名,enums：枚举集合{1:"正常",0:"停用"}}
    SETENUMCACHE(state, value) {
      var enums = state.EnumCache[value.name];
      if (!enums) {
        enums = [];
        Vue.set(state.EnumCache, value.name, enums);
      } //  如果枚举值不存在，则新建
      for (const key in value.enums) {
        if (enums.find(it => it.code == value.enums[key])) {
          // console.warn(`枚举类型：${value.name}已包含{ code: ${value.enums[key]}, descr: ${key} }`);
          continue;
        }
        var element = { code: value.enums[key], descr: key };
        enums.push(element);
      }
      // state.EnumCache[value.name] = enums;
    },

    //缓存inputbox值
    //入参：{datasource:"数据源名",total:总结果数,data:数据集[{Id:"123",Descr:"aaa"}]}
    SETINPUTBOXCACHE(state, value) {
      if (!value.datasource) {
        console.error('vuex.golbal.mutations.SETINPUTBOXCACHE', 'value.datasource无效', value);
        return;
      }
      var inputboxcache = state.InputboxCache[value.datasource];
      //  若输入控件缓存不存在，则缓存
      if (!inputboxcache) {
        inputboxcache = { data: value.data, total: value.total };
        Vue.set(state.InputboxCache, value.datasource, inputboxcache);
      } else {
        inputboxcache.total = value.total;
        if (!value.data || value.data.length == 0) {
          inputboxcache.data.splice(0, inputboxcache.data.length);
        }
        value.data.forEach(element => {
          if (inputboxcache.data.find(it => it.Id == element.Id)) {
            // console.warn(`输入控件：${value.datasource}已包含 ${JSON.stringify(element)}`);
          } else {
            inputboxcache.data.push(element);
          }
        });
        // state.InputboxCache[value.datasource] = inputboxcache;
      }
    },

    //清空inputbox缓存值
    //入参：{datasource:"数据源名"}
    CLEARINPUTBOXCACHE(state, value) {
      if (!value.datasource) {
        console.error('vuex.golbal.mutations.CLEARINPUTBOXCACHE', 'value.datasource无效', value);
        return;
      }
      var inputboxcache = state.InputboxCache[value.datasource];
      //  若缓存存在，则开始清空
      if (inputboxcache) {
        inputboxcache.total = 0; //  清空计数
        if (inputboxcache.data) {
          //  若数据存在，则清空数据
          inputboxcache.data.splice(0, inputboxcache.data.length);
        }
        // state.InputboxCache[value.datasource] = inputboxcache;
      }
    },
    //维护inputbox缓存值
    //入参：{datasource:"数据源名",data:{Id:"123",Descr:"aaa"}}
    MODIFYINPUTBOXCACHE(state, value) {
      if (!value.datasource) {
        console.error('vuex.golbal.mutations.MODIFYINPUTBOXCACHE', 'value.datasource无效', value);
        return;
      }
      var inputboxcache = state.InputboxCache[value.datasource];
      //  若缓存存在，则开始清空
      if (inputboxcache) {
        if (inputboxcache.data) {
          //  若数据存在，则清空数据
          var cache = inputboxcache.data.find(it => it.Id == value.data.Id); //  根据主键ID查找对象
          if (cache) {
            cache.Descr = value.data.Descr;
            cache.ParentId = value.data.ParentId;
            cache.ParentDescr = value.data.ParentDescr;
          } else {
            inputboxcache.total++; //  清空计数
            inputboxcache.data.push(value.data);
          }
        }
        // state.InputboxCache[value.datasource] = inputboxcache;
      }
    },
    //删除inputbox缓存值
    //入参：{datasource:"数据源名",data:{Id:"123"}}
    DELETEINPUTBOXCACHE(state, value) {
      if (!value.datasource) {
        console.error('vuex.golbal.mutations.DELETEINPUTBOXCACHE', 'value.datasource无效', value);
        return;
      }
      var inputboxcache = state.InputboxCache[value.datasource];
      //  若缓存存在，则开始清空
      if (inputboxcache) {
        // inputboxcache.total += 1; //  清空计数？？？
        if (inputboxcache.data) {
          //  若数据存在，则清空数据
          var index = inputboxcache.data.findIndex(it => it.Id == value.data.Id);
          if (index >= 0) {
            inputboxcache.total--;
            inputboxcache.data.splice(index, 1);
          }
        }
        // state.InputboxCache[value.datasource] = inputboxcache;
      }
    },
    //记录点击打开的Tab页里的组件
    ChangeOpenComponentOnTab(state, value) {
      state.OpenComponentOnTab = value;
    },
    CallRefreshMethod(state, value) {
      state.RefreshMethod = value;
    }
  },
  getters: {
    //  根据枚举类型名称获取枚举类型值集
    EnumList: (state, getters) => value => {
      return state.EnumCache[value.name];
    },
    //  根据枚举类型名称获取用于查询条件的枚举类型值集
    //  入参：{name：枚举类型名, nullDescr:全部}
    EnumListForQueryable: (state, getters) => value => {
      var result = [];
      result.push({ code: null, descr: value.nullDescr ? value.nullDescr : '全部' });
      var elements = getters.EnumList(value);
      if (elements) {
        elements.forEach(item => result.push(item));
      }
      return result;
    },
    //  根据枚举类型名称的descr获取枚举类型的code
    //  入参：{name：枚举类型名，descr：枚举名}
    EnumCode: (state, getters) => value => {
      var elements = getters.EnumList(value);
      if (elements) {
        var element = elements.find(item => item.descr == value.descr);
        if (element) {
          return element.code;
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    },
    //  根据枚举类型名称的code获取枚举类型的descr
    //  入参：{name：枚举类型名，code：枚举值}
    EnumDescr: (state, getters) => value => {
      var elements = getters.EnumList(value);
      if (elements) {
        var element = elements.find(item => item.code == value.code);
        if (element) {
          return element.descr;
        } else {
          return undefined;
        }
      } else {
        return undefined;
      }
    },

    //  根据datasource获取缓存
    //  入参：{datasource：数据类型名}
    InputboxCacheList: (state, getters) => value => {
      if (!value.datasource) {
        console.error('vuex.golbal.getters.InputboxCacheList', 'value.datasource无效', value);
        return [];
      }
      return state.InputboxCache[value.datasource];
    },

    //  根据datasource获取属性结构[{Id:"",Descr:"",children:[...]}]
    //  入参：{datasource：数据类型名,buildParentNode:是否构建父节点，parentNodeDescr：父节点名称，limitIds：限制ID}
    InputboxCacheTree: (state, getters) => value => {
      //构建树形结构
      var builder = (data, tree, parent) => {
        var entitys;
        if (parent && parent.Id) {
          entitys = data.filter(it => it.ParentId && it.ParentId == parent.Id).sort(strSort);
        } else {
          entitys = data.filter(it => !it.ParentId || data.filter(it2 => it2.Id == it.ParentId).length == 0).sort(strSort);
        }
        entitys.forEach(element => {
          var entity = { Id: element.Id, Code: element.Code, Descr: element.Descr };
          if (parent) {
            if (!parent.children) {
              parent.children = [];
            }
            parent.children.push(entity);
          } else {
            tree.push(entity);
          }
          builder(data, tree, entity);
        });
      };
      //排序
      var strSort = (a, b) => {
        var x = a.Code ? a.Code.toLowerCase() : a.Descr.toLowerCase();
        var y = b.Code ? b.Code.toLowerCase() : b.Descr.toLowerCase();
        if (x < y) {
          return -1;
        } else if (x > y) {
          return 1;
        } else {
          return 0;
        }
      };
      //根据ids找到本级及子节点
      var findchild = (data, newdata, ids) => {
        ids.forEach(id => {
          //如果数据中存在节点，且新数据中不存在，则插入数据
          if (data.findIndex(it => it.Id == id) >= 0 && newdata.findIndex(it => it.Id == id) < 0) {
            var item = data.filter(it => it.Id == id)[0];
            var newItem = {};
            for (const key in item) {
              newItem[key] = item[key];
            }
            newItem.ParentId = null; //顶级节点清除parentid
            newdata.push(newItem);
          }

          //如果该节点存在子集，则继续寻找子集节点
          if (data.findIndex(it => it.ParentId == id) >= 0 && newdata.findIndex(it => it.ParentId == id) < 0) {
            var items = data.filter(it => it.ParentId == id);
            newdata.push(...items);
            const itemIds = items.map(v => v.Id);
            //继续寻找子集的子集
            findchild(data, newdata, [itemIds]);
          }
        });
      };

      var tree = [];
      var data = [];
      var tmpdata = getters.InputboxCacheList(value);
      if (!tmpdata) return tree;
      if (value.limitIds) {
        var ids = [];
        if (_.isString(value.limitIds)) {
          ids = value.limitIds.splice(',');
        } else if (Array.isArray(value.limitIds) && value.limitIds.length > 0) {
          ids = value.limitIds;
        }
        findchild(tmpdata.data, data, ids);
      } else data = tmpdata.data;

      if (data) {
        if (value.buildParentNode) {
          var parent = { Id: null, Code: null, Descr: value.parentNodeDescr, children: [] };
          builder(data, tree, parent);
          tree.push(parent);
        } else builder(data, tree);
      }
      return tree;
    },

    //  根据datasource获取属性结构[{Id:"",Descr:"",children:[...]}]，无子级节点
    //  入参：{datasource：数据类型名,buildParentNode:是否构建父节点，parentNodeDescr：父节点名称，limitIds：限制ID}
    InputboxCacheTreeNoChild: (state, getters) => value => {
      var builder = (data, tree, parent) => {
        var entitys = data.filter(it => it.Id).sort(strSort);
        entitys.forEach(element => {
          var entity = { Id: element.Id, Code: element.Code, Descr: element.Descr };
          if (parent) {
            if (!parent.children) {
              parent.children = [];
            }
            parent.children.push(entity);
          } else {
            tree.push(entity);
          }
        });
      };
      var strSort = (a, b) => {
        var x = a.Code ? a.Code.toLowerCase() : a.Descr.toLowerCase();
        var y = b.Code ? b.Code.toLowerCase() : b.Descr.toLowerCase();
        if (x < y) {
          return -1;
        } else if (x > y) {
          return 1;
        } else {
          return 0;
        }
      };

      //根据ids找到本级及子节点
      var findchild = (data, newdata, ids) => {
        ids.forEach(element => {
          //如果数据中存在节点，且新数据中不存在，则插入数据
          if (data.findIndex(it => it.Id == id) >= 0 && newdata.findIndex(it => it.Id == id) < 0) {
            var item = data.filter(it => it.Id == id)[0];
            var newItem = {};
            for (const key in item) {
              newItem[key] = item[key];
            }
            newItem.ParentId = null; //顶级节点清除parentid
            newdata.push(newItem);
          }

          //如果该节点存在子集，则继续寻找子集节点
          if (data.findIndex(it => it.ParentId == id) >= 0 && newdata.findIndex(it => it.ParentId == id) < 0) {
            var items = data.filter(it => it.ParentId == id);
            newdata.push(...items);
            const itemIds = items.map(v => v.Id);
            //继续寻找子集的子集
            findchild(data, newdata, [itemIds]);
          }
        });
      };

      var tree = [];
      var data = [];
      var tmpdata = getters.InputboxCacheList(value);
      if (!tmpdata) return tree;
      if (value.limitIds) {
        var ids = [];
        if (_.isString(value.limitIds)) {
          ids = value.limitIds.splice(',');
        } else if (Array.isArray(value.limitIds) && value.limitIds.length > 0) {
          ids = value.limitIds;
        }
        findchild(tmpdata.data, data, ids);
      } else data = tmpdata.data;

      if (data) {
        if (value.buildParentNode) {
          var parent = { Id: null, Code: null, Descr: value.parentNodeDescr, children: [] };
          builder(data, tree, parent);
          tree.push(parent);
        } else builder(data, tree);
      }
      return tree;
    }
  }
};



// WEBPACK FOOTER //
// ./src/vuex/modules/golbal.js